export default class EvkFirmaResultadoModel {

    idInterviniente: number;
    firma: string;
}
